const RecoEvents = {
  FETCH_RECO_DATA_SUCCESS: 'reco/fetch_data_success',
  FETCH_RECO_DATA_PROGRESS: 'reco/fetch_data_progress',
  FETCH_RECO_DATA_NOT_FOUND: 'reco/fetch_data_not_found',
  FETCH_RECO_DATA_FAILED: 'reco/fetch_data_failed',
};

export default RecoEvents;
